module.exports = __webpack_public_path__ + "img/service2.a019e02e.png";